import { Injectable, inject } from '@angular/core';
import { ICustomWindow, WindowRefService } from './window-ref.service';

@Injectable({
    providedIn: 'root',
})
export class LanguageService {
    private _windowRef = inject(WindowRefService);

    private get Window(): ICustomWindow | undefined {
        return this._windowRef.NativeWindow;
    }

    getCulture(): string | null {
        if (!this.Window) {
            console.error('Window is not accessible! Cannot get culture.');

            return null;
        }

        const queryString = this.Window?.location.search;
        const urlParams = new URLSearchParams(queryString);

        return urlParams.get('culture');
    }
}
